import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FeaturesDisplay from '../DDM/FeaturesDisplay';

export default class NewOffersCitroen extends Component {
  compareTitles(title, subtitle) {
    return title === subtitle ? 'Citroen' : subtitle;
  }

  render() {
    const {
      title,
      subtitle,
      image,
      link,
      lazy,
      sealList,
      offer,
      showBadge,
      badge,
      onClickCard,
      ctaCardText
    } = this.props;

    const {
      secondary_call,
      main_call,
      featured,
      description,
      features,
      show_features_list,
    } = offer;

    return (
      <div className="new-offers-card">
        <a className="new-offers-card__link" href={link} onClick={onClickCard}>
          <img
            className={classNames('new-offers-card__image', {
              'swiper-lazy': lazy,
            })}
            src={image}
            alt={title}
            width="200"
            height="145"
          />
        </a>
        <div className="new-offers-card__content">
          <h3 className="new-offers-card__title">{title}</h3>
          <h4 className="new-offers-card__subtitle">
            {this.compareTitles(title, subtitle)}
          </h4>
          <ul
            className="new-offers-card__highlights"
            data-match-height="new-offers-card__highlights"
          >
            {sealList.map(item => (
              <li className="new-offers-card__highlight">
                <i className="icon icon-chevron" />
                {item}
              </li>
            ))}
          </ul>
          <div
            className="new-offers-card__price"
            data-match-height="new-offers-card__price"
          >
            {secondary_call && (
              <p className="new-offers-card__starting-price">
                {secondary_call}
              </p>
            )}
            {main_call && (
              <small className="new-offers-card__text-by">{main_call}</small>
            )}
            {featured && (
              <div className="new-offers-card__promotional-price">
                {featured}
              </div>
            )}
            {description && (
              <div className="new-offers-card__description">{description}</div>
            )}

            {show_features_list && features && (
              <FeaturesDisplay features={features} />
            )}
          </div>
          <a
            className="btn button button--large button--primary"
            href={link}
            onClick={onClickCard}
          >
            {ctaCardText || "Tenho interesse"}
          </a>
        </div>

        {showBadge && (
          <div className="new-offers-card__badge">
            <small>{badge}</small>
          </div>
        )}
      </div>
    );
  }
}

NewOffersCitroen.defaultProps = {
  title: '',
  subtitle: '',
  image: '',
  link: '',
  lazy: false,
  sealList: [],
  offer: {},
  showBadge: false,
  badge: '',
  onClickCard: () => {},
};

NewOffersCitroen.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  image: PropTypes.string,
  link: PropTypes.string,
  sealList: PropTypes.arrayOf(PropTypes.string),
  lazy: PropTypes.bool,
  offer: PropTypes.shape({
    secondary_call: PropTypes.string,
    main_call: PropTypes.string,
    featured: PropTypes.string,
    description: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.string),
    show_features_list: PropTypes.bool,
  }),
  showBadge: PropTypes.bool,
  badge: PropTypes.string,
  onClickCard: PropTypes.func,
};
